import { lazy } from 'react';

const routes = [
  {
    path: '/login',
    exact: true,
    name: 'Login',
    component: lazy(() => import('../../layouts/Login')),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/',
    exact: true,
    name: 'Dashboard',
    component: lazy(() => import('../../pages/dashboard'))
  },
  {
    path: '/clients',
    exact: true,
    name: 'Clients List',
    component: lazy(() => import('../../pages/clients/clients-list'))
  },
  {
    path: '/clients-apps',
    exact: true,
    name: 'Clients Apps List',
    component: lazy(() => import('../../pages/clients/clients-custom-app'))
  },
  {
    path: '/drafts',
    exact: true,
    name: 'Clients Draft List',
    component: lazy(() => import('../../pages/clients/drafts'))
  },
  {
    path: '/clients/add',
    exact: true,
    name: 'Add Client',
    component: lazy(() => import('../../pages/clients/create-client'))
  },
  {
    path: '/clients/edit/:uuid',
    exact: true,
    name: 'Update Client',
    component: lazy(() => import('../../pages/clients/create-client'))
  },
  {
    path: '/client-groups',
    exact: true,
    name: 'Client Groups',
    component: lazy(() => import('../../pages/clients/client-groups-list'))
  },
  {
    path: '/releases',
    exact: true,
    name: 'Releases',
    component: lazy(() => import('../../pages/releases/release-list'))
  },
  {
    path: '/releases/edit/:uuid',
    exact: true,
    name: 'Releases',
    component: lazy(() => import('../../pages/releases/release-edit'))
  },
  {
    path: '/builds',
    exact: true,
    name: 'Builds',
    component: lazy(() => import('../../pages/builds/build-list'))
  },
  {
    path: '/group-builds',
    exact: true,
    name: 'Group Builds',
    component: lazy(() => import('../../pages/builds/group-builds-list'))
  },
  {
    path: '/builds/:uuid',
    exact: true,
    name: 'Build',
    component: lazy(() => import('../../pages/builds/build-details'))
  },
  {
    path: '*',
    name: 'Error 404',
    component: lazy(() => import('../../layouts/Error404')),
    meta: {
      noAuth: true
    }
  }
];

export default routes;
